import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { EditSmspdpConfigTableComponent } from '../Table/edit-smspdp-config-table/edit-smspdp-config-table.component';
import { EditSmspdpEcowasConfigTableComponent } from '../Table/edit-smspdp-ecowas-config-table/edit-smspdp-ecowas-config-table.component';
import { SmspdpLiveMappingTableComponent } from '../Table/smspdp-live-mapping-table/smspdp-live-mapping-table.component';
import { SmspdpThresholdConfigTableComponent } from '../Table/smspdp-threshold-config-table/smspdp-threshold-config-table.component';
import { ViewSmspdpConfigTableComponent } from '../view-smspdp-config-table/view-smspdp-config-table.component';
import { ViewSmspdpEcowasConfigTableComponent } from '../view-smspdp-ecowas-config-table/view-smspdp-ecowas-config-table.component';
import { ViewSmspdpLiveMappingTableComponent } from '../view-smspdp-live-mapping-table/view-smspdp-live-mapping-table.component';
import { ViewSmspdpThresholdConfigTableComponent } from '../view-smspdp-threshold-config-table/view-smspdp-threshold-config-table.component';
import { DeleteSmspdpLiveDataComponent } from '../delete-smspdp-live-data/delete-smspdp-live-data.component';
import { EditEcowasAllowedGtComponent } from '../Table/edit-ecowas-allowed-gt/edit-ecowas-allowed-gt.component';
import { EditEcowasCcNdcComponent } from '../Table/edit-ecowas-cc-ndc/edit-ecowas-cc-ndc.component';
import { EditEcowasMccMncComponent } from '../Table/edit-ecowas-mcc-mnc/edit-ecowas-mcc-mnc.component';
import { EditEcowasinEcowasThresholdConfigComponent } from '../Table/edit-ecowasin-ecowas-threshold-config/edit-ecowasin-ecowas-threshold-config.component';
import { EditRrmsProbedbAllowedGtComponent } from '../Table/edit-rrms-probedb-allowed-gt/edit-rrms-probedb-allowed-gt.component';
import { EditRrmsProbedbCcNdcComponent } from '../Table/edit-rrms-probedb-cc-ndc/edit-rrms-probedb-cc-ndc.component';
import { EditRrmsProbedbMccMncComponent } from '../Table/edit-rrms-probedb-mcc-mnc/edit-rrms-probedb-mcc-mnc.component';
import { EditRrmsProbedbEcowasOrganizationComponent } from '../Table/edit-rrms-probedb-ecowas-organization/edit-rrms-probedb-ecowas-organization.component';
import { ViewEcowasWhitelistConfigTableComponent } from '../view-ecowas-whitelist-config-table/view-ecowas-whitelist-config-table.component';
import { ViewProbAllowedGtComponent } from '../view-prob-allowed-gt/view-prob-allowed-gt.component';
import { ViewAllowedGtComponent } from '../view-allowed-gt/view-allowed-gt.component';
import { EditEcowasOrganizationConfigTableComponent } from '../Table/edit-ecowas-organization-config-table/edit-ecowas-organization-config-table.component';
import { EditEcowasBusinessConfigTableComponent } from '../Table/edit-ecowas-business-config-table/edit-ecowas-business-config-table.component';

@Component({
  selector: 'app-sms-pdp-service-live-dashboard-data-table',
  templateUrl: './sms-pdp-service-live-dashboard-data-table.component.html',
  styleUrls: ['./sms-pdp-service-live-dashboard-data-table.component.scss']
})
export class SmsPdpServiceLiveDashboardDataTableComponent implements OnInit {

  @Input() tableData: any;
  businessConfigData:any=[]

  constructor(private dialog: MatDialog) { }

  ngOnInit(): void {
  }
   organizationConfigUpdateClick(row:any){
      const dialogRef = this.dialog.open(EditEcowasOrganizationConfigTableComponent, {
        width:'1500px',
        data:{rowData:row},
        panelClass: 'custom-modalbox',
        disableClose: true
        
      });
      
    }
    businessUpdateClick(row:any){
        console.log("row",row)
        console.log("data",this.businessConfigData)
        const dialogRef = this.dialog.open(EditEcowasBusinessConfigTableComponent, {
          width:'1500px',
          data: {rowData:row},
          panelClass: 'custom-modalbox',
          disableClose: true
          
        });
      }
      ecowasThresholdConfigClick(row:any){
        const dialogRef = this.dialog.open(EditEcowasinEcowasThresholdConfigComponent,{
          width:'1500px',
          data:{rowData:row},
          panelClass: 'custom-modalbox',
          disableClose: true
        });
      }
      probDbCcNdc(row:any){
        const dialogRef = this.dialog.open(EditRrmsProbedbCcNdcComponent,{
          width:'1500px',
          data:{rowData:row},
          panelClass: 'custom-modalbox',
          disableClose: true
        });
      }
      probDbMccMnc(row:any){
        const dialogRef = this.dialog.open(EditRrmsProbedbMccMncComponent,{
          width:'1500px',
          data:{rowData:row},
          panelClass: 'custom-modalbox',
          disableClose: true
        });
      }
      viewAllowedGt(row:any){
        console.log("row",row)
        const dialogRef = this.dialog.open(ViewAllowedGtComponent,{
       width:'1500px',
       height:'500px',
       data:{rowData:row},
       panelClass: 'custom-modalbox',
       disableClose: true
     });
      }
      smspdpLiveMappingClick(row:any){
        console.log("row",row)
        const dialogRef = this.dialog.open(SmspdpLiveMappingTableComponent, {
          width:'1200px',
          data:{rowData:row},
          panelClass: 'custom-modalbox',
          disableClose: true
          
        });
        dialogRef.afterClosed().subscribe(result => {
          console.log(result,'1111')
          if(result === true){
            
           
          }
          
        });
      }
  smspdpConfigClick(row:any){
    console.log("row",row)
    const dialogRef = this.dialog.open(EditSmspdpConfigTableComponent, {
      width:'1200px',
     data:{rowData:row},
      panelClass: 'custom-modalbox',
      disableClose: true
      
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result,'1111')
      if(result === true){
        
       
      }
      
    });
  }
  ecowasSmspdpConfigClick(row:any){
    console.log("row",row)
    const dialogRef = this.dialog.open(EditSmspdpEcowasConfigTableComponent, {
      width:'1200px',
      data:{rowData:row},
      panelClass: 'custom-modalbox',
      disableClose: true
      
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result,'1111')
      if(result === true){
        
       
      }
      
    });
  }

  smspdpThresholdClick(row:any){
    console.log("row",row)
    const dialogRef = this.dialog.open(SmspdpThresholdConfigTableComponent, {
      width:'1200px',
      data:{rowData:row},
      panelClass: 'custom-modalbox',
      disableClose: true
      
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result,'1111')
      if(result === true){
        
       
      }
      
    });
    
  }


  // ecowasAllowedGt(row:any){
  //   console.log("row",row)
  //   const dialogRef = this.dialog.open(EditEcowasAllowedGtComponent,{
  //     width:'1500px',
  //     data:{rowData:row},
  //     panelClass: 'custom-modalbox',
  //     disableClose: true
  //   });
  // }

  ecowasCcNdcClick(row:any){
    const dialogRef = this.dialog.open(EditEcowasCcNdcComponent,{
      width:'1500px',
      data:{rowData:row},
      panelClass: 'custom-modalbox',
      disableClose: true
    });
  }
  ecowasMncMccClick(row:any){
    const dialogRef = this.dialog.open(EditEcowasMccMncComponent,{
      width:'1500px',
      data:{rowData:row},
      panelClass: 'custom-modalbox',
      disableClose: true
    });
  }
 
  // probDbAllowedGt(row:any){
  //   const dialogRef = this.dialog.open(EditRrmsProbedbAllowedGtComponent,{
  //     width:'1500px',
  //     data:{rowData:row},
  //     panelClass: 'custom-modalbox',
  //     disableClose: true
  //   });
  // }
  viewProbAllowGt(row:any){
    console.log("row",row)
       const dialogRef = this.dialog.open(ViewProbAllowedGtComponent,{
      width:'1500px',
      height:'500px',
      data:{rowData:row},
      panelClass: 'custom-modalbox',
      disableClose: true
    });

  }
 
 
probDbOrganizationClick(row:any){
  const dialogRef = this.dialog.open(EditRrmsProbedbEcowasOrganizationComponent,{
    width:'1500px',
    data:{rowData:row},
    panelClass: 'custom-modalbox',
    disableClose: true
  });
}

viewWhitelistClick(row:any){
  console.log("row",row)
  const dialogRef = this.dialog.open(ViewEcowasWhitelistConfigTableComponent, {
    width:'1500px',
    height:'500px',
    data: {rowData:row },
    panelClass: 'custom-modalbox',
    disableClose: true
    
  });
  
}

  // viewsmspdpConfigClick(){
  //   const dialogRef = this.dialog.open(ViewSmspdpConfigTableComponent, {
  //     width:'900px',
  //     height:'500px',
  //     panelClass: 'custom-modalbox',
  //     disableClose: true
      
  //   });
  //   dialogRef.afterClosed().subscribe(result => {
  //     console.log(result,'1111')
  //     if(result === true){
        
       
  //     }
      
  //   });
  // }
  // viewecowasSmspdpConfig(){
  //   const dialogRef = this.dialog.open(ViewSmspdpEcowasConfigTableComponent, {
  //     width:'900px',
  //     height:'500px',
  //     panelClass: 'custom-modalbox',
  //     disableClose: true
      
  //   });
  //   dialogRef.afterClosed().subscribe(result => {
  //     console.log(result,'1111')
  //     if(result === true){
        
       
  //     }
      
  //   });
  // }
  // viewsmspdpLiveMappingClick(){
  //   const dialogRef = this.dialog.open(ViewSmspdpLiveMappingTableComponent, {
  //     width:'900px',
  //     height:'500px',
  //     panelClass: 'custom-modalbox',
  //     disableClose: true
      
  //   });
  //   dialogRef.afterClosed().subscribe(result => {
  //     console.log(result,'1111')
  //     if(result === true){
        
       
  //     }
      
  //   });
  // }
  // viewsmspdpThreshold(){
  //   const dialogRef = this.dialog.open(ViewSmspdpThresholdConfigTableComponent, {
  //     width:'900px',
  //     height:'500px',
  //     panelClass: 'custom-modalbox',
  //     disableClose: true
      
  //   });
  //   dialogRef.afterClosed().subscribe(result => {
  //     console.log(result,'1111')
  //     if(result === true){
        
       
  //     }
      
  //   });
   
  // }
  deleteSmspdp(row:any){
    const dialogRef = this.dialog.open(DeleteSmspdpLiveDataComponent, {
      width:'500px',
     data:{rowData:row},
      panelClass: 'custom-modalbox',
      disableClose: true
      
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result,'1111')
      if(result === true){
        
       
      }
      
    });
   
  }

}
